import React, { useEffect, useMemo, useState } from "react";
import "./leaderboard.css";
import { Table } from "../../components/Table/Table";
import LeaderBoardDate from "../../components/Leaderboard/LeaderBoardDate";
import { useTable } from "react-table";

export const Leaderboard = () => {
  // Toggle the row visibility
  const [columnVisibility, setColumnVisibility] = useState({
    isPLP: true,
    isProfit: false,
    isKOTTO: false,
  });

  // Highlight the row in which current user data is there.
  const [selectedUserRow, setSelectedUserRow] = useState("2");

  const columns = useMemo(
    () => [
      {
        Header: "Position",
        accessor: "position",
      },
      {
        Header: "Username",
        accessor: "userName",
      },
      {
        Header: "PLP",
        accessor: "plp",
      },
      {
        Header: "Profit",
        accessor: "profit",
      },

      {
        Header: "KOTTO",
        accessor: "kotto",
      },
      {
        Header: "Total P",
        accessor: "total",
      },
    ],
    []
  );
  const data = [
    {
      position: "1",
      userName: "Ace",
      plp: "120.7",
      profit: "226.00",
      kotto: 1,
      total: 1200,
    },
    {
      position: "2",
      userName: "Luffy",
      plp: "120.7",
      profit: "226.00",
      kotto: 1,
      total: 1200,
    },
    {
      position: "3",
      userName: "Sanji",
      plp: "120.7",
      profit: "226.00",
      kotto: 1,
      total: 1200,
    },
    {
      position: "4",
      userName: "Zoro",
      plp: "120.7",
      profit: "226.00",
      kotto: 1,
      total: 1200,
    },
  ];

  const {
    getTableProps,
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    rows, // rows for the table based on the data passed
    prepareRow,
    allColumnsHidden,
    setHiddenColumns,
  } = useTable({
    columns,
    data,
  });

  useEffect(() => {
    if (columnVisibility.isPLP) {
      setHiddenColumns(["profit", "kotto"]);
    } else if (columnVisibility.isProfit) {
      setHiddenColumns(["plp", "kotto"]);
    } else if (columnVisibility.isKOTTO) {
      setHiddenColumns(["plp", "profit"]);
    }
  }, [columnVisibility]);

  return (
    <main className="wrapper_leaderBoard">
      <LeaderBoardDate
        setColumnVisibility={setColumnVisibility}
        columnVisibility={columnVisibility}
      />
      <section className="leaderBoard_section">
        <table className="reactTable-table" {...getTableProps()}>
          <thead className="reactTable-head">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps()}
                    className={`${
                      column.Header === "PLP" ||
                      column.Header === "Profit" ||
                      column.Header === "KOTTO"
                        ? "table-head-bg-color"
                        : ""
                    }`}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="reactTable-body" {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    console.log(row);
                    return (
                      <td
                        className={
                          row.values.position === selectedUserRow &&
                          "table-head-bg-color"
                        }
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    </main>
  );
};
